import { StringLookup } from './string-lookup';

export class Person {
  id: number;
  firstName: string;
  lastName: string;
  location: string;
  tenantId: string;
  email: string;
}
